const MSGRecipientType = {
    VehicleClass: 'VehicleClass',
    Vehicle: 'Vehicle',
    Route: 'Route',
    AllRoutes: 'AllRoutes',
    Dispatcher: 'Dispatcher',
    AllDispatchers: 'AllDispatchers'
}

export default MSGRecipientType;